// src/pages/NotFound.tsx
//
// 404 page. Friendly + minimalist.

import { Home } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
      <div className="text-7xl font-510 tracking-tighter text-benchmark-teal-bright">
        404
      </div>
      <h1 className="mt-4 text-2xl font-510 tracking-tight text-fg-primary">
        {t("notFound.title", "Page not found")}
      </h1>
      <p className="mt-2 text-sm text-fg-tertiary">
        {t("notFound.body", "The resource you requested doesn't exist or has been moved.")}
      </p>
      <Button href="/" size="lg" className="mt-6">
        <Home className="h-4 w-4" strokeWidth={1.5} />
        {t("notFound.back", "Back to home")}
      </Button>
    </div>
  );
}
